module.exports = __webpack_public_path__ + "static/media/PACIFailed.d65526a8.svg";